import React, { FC, useContext } from 'react'
import { Link } from 'react-router-dom'
import { ThemeContext } from "~contexts/ThemeContext";
import { ScreenContext } from "~contexts/ScreenContext";
import { Divider, Dropdown, Menu, Switch, Typography } from 'antd';
import type { MenuProps } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import styled from 'styled-components'
// import FormattedMessage from './FormattedMessage'
import { useThemeSwitcher } from "react-css-theme-switcher"
// import { useTranslation } from 'react-i18next'
// import { availableLanguages } from '~utils/i18n'

const { Text } = Typography

interface ProfileButtonProps {
    className?: string
    username: string
    role?: string
}

type MenuItem = Required<MenuProps>['items'][number];
const ProfileButton: FC<ProfileButtonProps> = ({ className, username, role }) => {
    const { theme, toggleTheme } = useContext(ThemeContext)
    const { screen, toggleScreen } = useContext(ScreenContext)
    // const [visible, setVisible] = useState(false)

    // const onVisibleChange = (visible: boolean) => setVisible(visible)
    // const { i18n } = useTranslation()
    // const [current, setCurrent] = React.useState(i18n.language);
    const { switcher, themes } = useThemeSwitcher();

    const toggleTheme2 = (isChecked: boolean) => {
        switcher({ theme: isChecked ? themes.dark : themes.light });
    }


    // const [isProfileModalOpen, setIsProfileModalOpen] = useState<boolean>(false);
    // const toggleModalProfile = () => setIsProfileModalOpen(!isProfileModalOpen)

    // const [isChangePasswordOpen, setIsChangePasswordOpen] = useState<boolean>(false);
    // const toggleModalChangePassword = () => setIsChangePasswordOpen(!isChangePasswordOpen)

    const getItem = (
        label: React.ReactNode,
        key?: React.Key | null,
        icon?: React.ReactNode,
        children?: MenuItem[],
        type?: 'group',
    ): MenuItem => {
        return {
            key,
            icon,
            children,
            label,
            type,
        } as MenuItem;
    }

    // const itemLang: any[] = Object.entries(availableLanguages).map((language: any) => {
    //     return getItem(
    //         <div onClick={() => { i18n.changeLanguage(language[0]); setCurrent(language[0]) }}>
    //             {language[1]}
    //         </div>, language[0])
    // })

    const items: MenuItem[] = [
        // getItem(
        //     <div onClick={toggleModalProfile}>
        //         Profile
        //     </div>, "m-0"),
        // getItem(
        //     <div onClick={toggleModalChangePassword}>
        //         Change Password
        //     </div>, "m-1"),
        getItem(
            <div className="d-flex">
                <span>โหมด</span>
                <Switch
                    className='ms-auto'
                    checkedChildren={<i className="fad fa-moon"></i>}
                    unCheckedChildren={<i className="fa fa-sun"></i>}
                    checked={theme === "dark" ? true : false}
                    onClick={(e) => {
                        toggleTheme(e)
                        toggleTheme2(e)
                    }}
                />
            </div>
            , 'm-2'),
        getItem(
            <div className="d-flex">
                <span>เต็มหน้าจอ</span>
                <Switch
                    className='ms-auto'
                    checkedChildren={"เปิด"}
                    unCheckedChildren={"ปิด"}
                    defaultChecked={screen === "full" ? true : false}
                    onClick={(e) => {
                        toggleScreen(e)
                    }}
                />
            </div>
            , 'm-3'),
        getItem(
            <Divider className="mt-2 mb-0" />
            , 'm-4'),
        getItem(
            <Link to="/logout">
                <Text type="danger">
                    <i className="fas fa-sign-out me-2"></i> ออกจากระบบ
                </Text>
            </Link>
            , 'm-5'),
    ];
    const menu = (
        <Menu className="profile-link-hover" items={items} />
    );
    return (
        <>
            <div className={"profile-button " + className}>
                <Dropdown overlay={menu} trigger={["click"]} placement="bottom" >
                    <Profile className="ant-dropdown-link">
                        <div className="d-lg-none">
                            <UserOutlined className="profile-icon" style={{ fontSize: '20px', padding: '4px 8px' }} />
                        </div>
                        <div className="profile-wrapper d-none d-lg-flex">
                            <div className="profile-char">
                                <span>{username?.charAt(0)}</span>
                            </div>
                            <div className="profile-info">
                                <div className="profile-username">{username}</div>
                                <small className="profile-permission">{role?.toLocaleUpperCase()}</small>
                            </div>
                        </div>
                        <i className="far fa-chevron-down profile-chevron-down"></i>
                    </Profile>
                </Dropdown>
            </div>
            {/* <ProfileModal
                isOpen={isProfileModalOpen}
                close={() => toggleModalProfile()}
            />
            <ChangePasswordAccount
                isOpen={isChangePasswordOpen}
                close={toggleModalChangePassword}
                username={username}
            /> */}
        </>
    )
}

export default ProfileButton

const Profile = styled.div`
    display: flex;
    align-items: center;
    line-height: 1.25;
`